import { useTranslation } from "react-i18next";

import InfoList from "./InfoList";

import {
  CheckCircleIcon,
  DataAppendIcon,
  FileExclamationIcon,
} from "../../assets/icons";

import "./DataAppend.scss";

const AppendInfoSection = () => {
  const { t } = useTranslation();

  // Config array for info sections
  const infoSections = [
    {
      key: "whatYouNeedToKnow",
      icon: FileExclamationIcon,
      alt: "File Exclamation Icon",
      columnClass: "info-column--medium",
      title: t("dataAppend.infoSection.whatYouNeedToKnow.title"),
      items: [
        t("dataAppend.infoSection.whatYouNeedToKnow.mixedData"),
        t("dataAppend.infoSection.whatYouNeedToKnow.columnStructure"),
        t("dataAppend.infoSection.whatYouNeedToKnow.duplicateRemoval"),
        t("dataAppend.infoSection.whatYouNeedToKnow.sameSheetName"),
      ],
    },
    {
      key: "beforeYouAppend",
      icon: DataAppendIcon,
      alt: "Data Append Icon",
      columnClass: "info-column--narrow",
      title: t("dataAppend.infoSection.beforeYouAppend.title"),
      summary: t("dataAppend.infoSection.beforeYouAppend.summary"),
      items: [
        t("dataAppend.infoSection.beforeYouAppend.rowsAndDateRange"),
        t("dataAppend.infoSection.beforeYouAppend.gapsAndConflicts"),
      ],
    },
    {
      key: "whatWillStaySame",
      icon: CheckCircleIcon,
      alt: "Check Circle Icon",
      columnClass: "info-column--wide",
      title: t("dataAppend.infoSection.whatWillStaySame.title"),
      items: [
        t("dataAppend.infoSection.whatWillStaySame.settingsUnchanged"),
        t("dataAppend.infoSection.whatWillStaySame.sheetSelection"),
      ],
    },
  ];

  return (
    <div className="append-info-section">
      {infoSections.map((section) => (
        <div className={`info-column ${section.columnClass}`} key={section.key}>
          <div className="info-header">
            <section.icon className="info-icon" alt={section.alt} />
            {section.title}
          </div>
          {section.summary && (
            <div className="info-text">{section.summary}</div>
          )}
          <InfoList items={section.items} />
        </div>
      ))}
    </div>
  );
};

export default AppendInfoSection;
